import React from 'react';


export function ViewOrganizationRequest(props) {
  return <div>view org req</div>
}